import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"text-red-700 dark:text-red-200\">{{yield}}</div>\n",{ moduleName: "seshy/components/field-error.hbs" })